/**
 * [ File :: G_ImageGrid.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageGrid.js
 * @설명 : "이미지와 그리드"를 이용하는 객체를 상속해주기 위한 중간 객체
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Real       from 'canvas/base/dev/child/base/B_Real';
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld';
import B_Image      from 'canvas/base/dev/child/image/B_Image';
import B_GridChild  from 'canvas/base/dev/child/grid/B_GridChild';
import G_GridChild  from 'canvas/grid/dev/child/grid/G_GridChild';
import G_ValueText from 'canvas/grid/dev/child/text/G_ValueText';
import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';

let mix = (superclass) => new MixinBuilder(superclass);

const G_ImageGrid = (function() {
	return class extends mix(B_Real).with(B_ChildWorld, B_Image, B_GridChild, G_GridChild) {
		constructor(obj) {
			super(obj);

			this._dontGet = obj.dontGet

			if (obj.valueVisible === true && typeof this._value !== 'undefined') {
				const RES = this.CODMOS._res[obj.res]
				this._valueObj = new G_ValueText({
					text: this._isRandom === true ? '?' : this._value,
					size: 25,
					style: 'bold',
					font: "'Yanolja', sans-serif",
					color: 'black',
					gridDisX: this._gridDisX,
					gridDisY: this._gridDisY,
					x: this._gridX,
					y: this._gridY,
					pointX: typeof RES.valueX !== 'undefined' ? RES.valueX : 50,
					pointY: typeof RES.valueY !== 'undefined' ? RES.valueY : 50
				})
				this._objParent._container.addChild(this._valueObj._object)
			}
		}

		/**
		* [ Function :: _remove ]
		*
		* @DES :: 객체가 제거 될 때 valueObj도 제거
		* @IP1 :: null
		* @O.P :: null
		*/
		_remove () {
			if (this._valueObj) this._valueObj._object.text = ''
			super._remove()
		}
	}
}());


export default G_ImageGrid;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageGrid.js